import { Dispatch } from 'redux';
import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import { 
  getPreviouslyPurchasedItemsSuccess,
  getPreviouslyPurchasedItemsFailure
} from '../actions';

// Action to fetch business items for a specific business
export const fetchPreviouslyPurchasedItems = (more: boolean = false) => {
  return async (dispatch: Dispatch, getState: () => ReduxState) => {
    try {
      // Get the loginToken from the Redux state
      const { auth, user } = getState();
      const loginToken = auth.loginToken;
      const userId = user.user?._id;
      let fetchedBusinessItems: any[] = [];
      // Construct the headers with X-Auth-Token
      const headers = {
        'X-Auth-Token': loginToken,
      };
      // Construct the URL with query parameters
      let url = `/marketplace-service/api/v1/items/previous-purchases/${userId}`
      const response = await backend.get(url, { headers });

      if (response.status === 200) {
        fetchedBusinessItems = response.data.items;
        dispatch(getPreviouslyPurchasedItemsSuccess(fetchedBusinessItems));
      } else {
        dispatch(getPreviouslyPurchasedItemsFailure('Failed to fetch business items.'));
      }
    } catch (error) {
      console.error('Error fetching business items:', error);
      dispatch(getPreviouslyPurchasedItemsFailure('An error occurred while fetching business items.'));
    }
  };
};